import { useState, useEffect, useCallback } from "react";
import DashboardLayout from "../../common/DashboardLayout";
import { Icon1, Icon2, User2, course02 } from "../../imagepath";
import { Link } from "react-router-dom";
import AdminServices from "../AdminServices";
import $ from "jquery";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net";
import { Edit, Trash, Trash2 } from "react-feather";
import TeacherServices from "../TeacherServices";
import { Snackbar, Alert } from '@mui/material';
import PasswordResetModal from "../PasswordResetModal";
import { activationLabel, addedOn } from "../../../utils/teacherStatus";

const TeachersLists = () => {
  const [isClassAdded, setIsClassAdded] = useState([false]);
  const [teachers, setTeachers] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const [isDeleteConfirmPopup, setIsDeleteConfirmPopup] = useState(false);
  const [isEditModal, setIsEditModal] = useState(false);
  const [confirmedDeleteUserId, setConfirmedDeleteUserId] = useState("");
  const [selectedTeacher, setSelectedTeacher] = useState({
    name: "",
    email: "",
    address: "",
  });
  const [isOpenNotification, setIsOpenNotification] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPasswordResetModal, setShowPasswordResetModal] = useState(false);
  const [passwordResetEmail, setPasswordResetEmail] = useState("");

  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  const toggleClass = (index) => {
    const updatedClasses = [...isClassAdded];
    updatedClasses[index] = !updatedClasses[index];
    setIsClassAdded(updatedClasses);
  };

  const fetchTeachers = useCallback(async () => {
    try {
      const response = await AdminServices.getAllTeachers({
        page: currentPage,
        search,
      });
      console.log("getAllTeachers: ", response);
      setTeachers(response.teachers); // Ensure this is an array
      setTotalPages(response.totalPages);
    } catch (error) {
      console.error("Error fetching Teachers:", error);
    }
  }, [currentPage, search]); // Include currentPage and search as dependencies

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleDeleteData = async () => {
    try {
      await TeacherServices.deleteTeacher(confirmedDeleteUserId);
      setIsDeleteConfirmPopup(false);
      setConfirmedDeleteUserId("");

      await fetchTeachers(); // Re-fetch teachers from backend

      if ($.fn.DataTable.isDataTable("#teachersTable")) {
        $("#teachersTable").DataTable().destroy(); // ✅
      }
    } catch (error) {
      console.log("Failed to delete teacher:", error);
      setIsDeleteConfirmPopup(false);
      setConfirmedDeleteUserId("");
    }
  }

  const handleCloseNotification = () => {
    setIsOpenNotification(false);
    setSuccessMessage("");
    setErrorMessage("");
  }

  const handleEditTeacher = (type, e) => {
    setSelectedTeacher({
      ...selectedTeacher,
      [type]: e.target.value
    })
  }

  const isValid = () => {
    if (
      !selectedTeacher.name.trim() ||
      !selectedTeacher.email.trim() ||
      !selectedTeacher.address.trim()
    ) {
      setIsOpenNotification(true);
      setErrorMessage("All fields are required");
      return false;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(selectedTeacher.email)) {
      setIsOpenNotification(true);
      setErrorMessage("Enter a valid email address");
      return false;
    }

    return true;
  };

  const handleUpdate = async () => {
    if (!isValid()) return;

    if (isLoading) return;

    setIsLoading(true);

    try {
      const updatedTeacher = await AdminServices.updateTeacher(selectedTeacher);

      if (updatedTeacher) {
        setSuccessMessage("Teacher updated successfully!");
        setIsOpenNotification(true);
        setIsEditModal(false);
        await fetchTeachers(); // Re-fetch teachers from backend

        if ($.fn.DataTable.isDataTable("#teachersTable")) {
          $("#teachersTable").DataTable().destroy(); // ✅
        }
      }
      setIsLoading(false);
    } catch (err) {
      setIsOpenNotification(true);
      setErrorMessage(err?.response?.data?.error || err);
      setIsLoading(false);
    }
  }

  const handleOpenResetPassword = (teacher) => {
    setPasswordResetEmail(teacher?.email || "");
    setShowPasswordResetModal(true);
  };

  useEffect(() => {
    fetchTeachers();
  }, [fetchTeachers]); // fetchTeachers now has stable dependencies

  useEffect(() => {
    if (teachers.length === 0) return; // Prevent initializing if no data

    if ($.fn.DataTable.isDataTable("#teachersTable")) {
      $("#teachersTable").DataTable().destroy(); // Destroy old instance before reinitializing
    }

    $("#teachersTable").DataTable({
      responsive: true,
      autoWidth: false,
      paging: true, // ✅ Enable Pagination
      searching: true,
      ordering: true,
      pageLength: 10, // ✅ Set default entries per page
      lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]], // ✅ Add pagination options,
    });

    $('#teachersTable').closest('.dt-layout-table').addClass('dt-custom-table');
  }, [teachers]);

  return (
    <DashboardLayout
      role="admin"
      layoutType="topnav"
      activeMenu="Teachers List"
      showBreadcrumbs={false}
    >
      <div className={`admincontent ${sidebarVisible ? 'col-xl-12 col-lg-12' : 'col-12'}`}>
        {/* Dashboard Grid */}
        {/* <div className="row justify-content-center">
                                    <div className="col-lg-4 col-md-6 d-flex">
                                        <div className="card dash-info flex-fill">
                                            <div className="card-body">
                                                <h5>Total School</h5>
                                                <h2>1</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 d-flex">
                                        <div className="card dash-info flex-fill">
                                            <div className="card-body">
                                                <h5>Total User</h5>
                                                <h2>2</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 d-flex">
                                        <div className="card dash-info flex-fill">
                                            <div className="card-body">
                                                <h5>Total Course</h5>
                                                <h2>1</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
        {/* /Dashboard Grid */}
        <div className="row">
          {/* Course Grid */}
          <div className="custom-table">
            <table
              id="teachersTable"
              className="table table-nowrap mb-0"
            >
              <thead>
                <tr>
                  <th></th>
                  <th>Action</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>School Name</th>
                  <th>Signed up</th>
                  <th>Added On</th>
                  <th>Payment Status</th>
                  <th>Payment Date</th>
                  <th>Renewal Date</th>
                  <th>Payment By</th>
                  <th>Course Completed Date</th>
                </tr>
              </thead>
              <tbody>
                {teachers.map((teacher, index) => (
                  <tr key={teacher._id || teacher.id || teacher.email || index}>
                    <td>{index + 1}</td>
                    <td className="teachers-actions-cell">
                      <div className="teachers-actions-wrap">
                        {/* Sized by its own text. This carried `action-icon`,
                            a fixed 40x40 chip from the theme stylesheet meant
                            for a single glyph - "View Certificates" is about
                            118px wide, so it overflowed ~38px each side of a
                            42px box and painted over the row-number column
                            beside it. The class was used nowhere else in the
                            codebase. Matching the Reset Password button next
                            to it also makes the two read as one control set. */}
                        {teacher?.school_id ? '' :
                          <Link
                            to="/certificates"
                            className="btn btn-sm btn-outline-primary"
                          >
                            View Certificates
                          </Link>}
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => handleOpenResetPassword(teacher)}
                          title="Reset Password"
                          disabled={isLoading}
                        >
                          Reset Password
                        </button>
                        <Edit className="edit-icon" onClick={() => {
                          setSelectedTeacher(teacher);
                          setIsEditModal(true);
                        }} />
                        <Trash2 className="delete-data" onClick={() => {
                          setConfirmedDeleteUserId(teacher._id || teacher.id);
                          setIsDeleteConfirmPopup(true);
                        }} />
                      </div>
                    </td>
                    <td>
                      {teacher.firstName || 'N/A'}
                    </td>
                    <td>
                      {teacher.lastName || 'N/A'}
                    </td>
                    <td>
                      {teacher.email}
                    </td>
                    <td>{teacher.school_id ? teacher.school_id.name : "N/A"}</td>
                    <td>{activationLabel(teacher)}</td>
                    <td>{addedOn(teacher)}</td>
                    <td>
                      {teacher.payment ? (
                        <div>
                          <div className={teacher.payment.isPaid ? "text-success" : "text-danger"}>
                            {/* "Paid in Full" described clearing a balance. Both plans
                                renew until cancelled, so a paid subscription is simply
                                active. */}
                            <strong>{teacher.payment.paymentStatus || (teacher.payment.isPaid ? "Active" : "Unpaid")}</strong>
                          </div>
                          {teacher.payment.isInstallmentPlan && teacher.payment.isPaid && (
                            <div className="small text-info mt-1">
                              Monthly Plan
                            </div>
                          )}
                          {teacher.payment.isPaid && !teacher.payment.isInstallmentPlan && (
                            <div className="small text-success mt-1">
                              Auto-renewal: 1 year
                            </div>
                          )}
                        </div>
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td>
                      {teacher.payment?.paymentDate
                        ? new Date(teacher.payment.paymentDate).toLocaleDateString()
                        : teacher.payment?.startDate
                          ? new Date(teacher.payment.startDate).toLocaleDateString()
                          : teacher.payment?.createdAt
                            ? new Date(teacher.payment.createdAt).toLocaleDateString()
                            : "N/A"}
                    </td>
                    <td>
                      {teacher.payment?.renewalDate ? (
                        <div>
                          <div className={new Date(teacher.payment.renewalDate) < new Date() ? "text-danger" : "text-info"}>
                            {new Date(teacher.payment.renewalDate).toLocaleDateString()}
                          </div>
                          {teacher.payment.isInstallmentPlan && (
                            <div className="small text-muted mt-1">
                              Auto-renewal: Monthly
                            </div>
                          )}
                          {teacher.payment.isPaid && !teacher.payment.isInstallmentPlan && (
                            <div className="small text-muted mt-1">
                              Auto-renewal: Annual
                            </div>
                          )}
                        </div>
                      ) : teacher.payment ? (
                        <span className="text-muted">Not set</span>
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td>
                      {teacher.payment
                        ? teacher.payment.schoolId
                          ? "School"
                          : teacher.payment.userId
                            ? "Individual Teacher"
                            : "N/A"
                        : "N/A"}
                    </td>
                    <td>
                      {teacher?.quizResults?.[0]?.completionDate
                        ? new Date(
                          teacher.quizResults[0].completionDate
                        ).toLocaleString()
                        : "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {/* <div className="dash-pagination">
                  <div className="row align-items-center">
                    <div className="col-6">
                      <p>Page 1 of 2</p>
                    </div>
                    <div className="col-6">
                      <ul className="pagination">
                        <li className="active">
                          <Link to="#">1</Link>
                        </li>
                        <li>
                          <Link to="#">2</Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="bx bx-chevron-right" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div> */}
      </div>
      {isDeleteConfirmPopup ?
        (<div className="delete-confirm-popup">
          <div className="popup-content">
            <p>Are you sure you want to delete this user?</p>
            <div className="popup-buttons">
              <button onClick={handleDeleteData}>Yes</button>
              <button onClick={() => {
                setConfirmedDeleteUserId("");
                setIsEditModal(false);
              }}>Cancel</button>
            </div>
          </div>
        </div>)
        :
        <></>
      }
      {isEditModal ?
        (<div className="edit-modal">
          <div className="modal-content">
            <h4>Update Info</h4>
            <div className="modal-input-group">
              <label>Teacher Name</label><br />
              <input value={selectedTeacher.name} onChange={(e) => handleEditTeacher("name", e)} />
            </div>
            <div className="modal-input-group">
              <label>Email</label><br />
              <input value={selectedTeacher.email} onChange={(e) => handleEditTeacher("email", e)} />
            </div>
            <div className="modal-input-group">
              <label>Address</label><br />
              <input value={selectedTeacher.address} onChange={(e) => handleEditTeacher("address", e)} />
            </div>
            <div className="modal-buttons">
              <button onClick={handleUpdate}>Update</button>
              <button onClick={() => {
                setSelectedTeacher({
                  name: "",
                  email: "",
                  address: "",
                });
                setIsEditModal(false);
              }}>Cancel</button>
            </div>
          </div>
        </div>)
        :
        <></>
      }
        <PasswordResetModal
          open={showPasswordResetModal}
          onClose={() => {
            setShowPasswordResetModal(false);
            setPasswordResetEmail("");
          }}
          prefillEmail={passwordResetEmail}
        />
      <Snackbar
        open={isOpenNotification}
        autoHideDuration={5000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseNotification} severity={successMessage ? "success" : "error"} sx={{ width: '100%' }}>
          {successMessage || errorMessage}
        </Alert>
      </Snackbar>
    </DashboardLayout>
  );
};

export default TeachersLists;
